import * as actionTypesNV04 from "./actionTypesNV04";
import { WarehouseSnapshot } from "../../models/NV04";

export const fetchSnapshotRequest = (companyId: number, selectedYear?: number, selectedMonth?: number) => ({
  type: actionTypesNV04.NV04_SNAPSHOT_GET,
  payload: {
    companyId,
    selectedYear,
    selectedMonth,
  },
});

export const fetchSnapshotSuccess = (data: WarehouseSnapshot) => ({
  type: actionTypesNV04.NV04_SNAPSHOT_SUCCESS,
  payload: data,
});

export const fetchSnapshotFailure = (error: string) => ({
  type: actionTypesNV04.NV04_SNAPSHOT_FAILURE,
  payload: error,
});

export const clearNV04Data = () => ({
  type: actionTypesNV04.NV04_CLEAR_DATA,
});
